/**
 * Key Performance 指标卡「行业基准」浮窗：白名单、浮窗文案与表格行（中英维护）
 */

/**
 * gameCode -> 展示行业基准入口的 metrics_name 列表（与接口/constant 卡片 key 一致）
 */
export const KEY_PERFORMANCE_BENCHMARK_METRICS_BY_GAME: Readonly<
Record<string, readonly string[]>> = {
  gst: ['D2(T-1)'],
};

/**
 * 当前游戏当前卡片是否应展示行业基准（由页面开关 + 本配置共同决定）
 */
export function isKeyPerformanceBenchmarkCardConfigured(
  gameCode: string | undefined | null,
  metricsName: string | undefined,
): boolean {
  if (!gameCode || !metricsName) {
    return false;
  }
  const metricsList = KEY_PERFORMANCE_BENCHMARK_METRICS_BY_GAME[gameCode];
  return metricsList?.includes(metricsName) ?? false;
}

export interface IKeyPerformanceBenchmarkTableRow {
  nameEn: string;
  nameCn: string;
  targetEn: string;
  targetCn: string;
  color: string;
}

/** 与 dune `MetricCard.benchmarkConfig` + VsBenchmarkBtn 一致的按钮埋点（buttonId 需后台分配） */
export interface IKeyPerformanceBenchmarkBuriedLog {
  pageId: string;
  buttonId: string;
  extInfo?: string;
  buttonName?: string;
  typeId?: string;
}

export interface IKeyPerformanceBenchmarkPopoverConfig {
  titleEn: string;
  titleCn: string;
  columnMetricsEn: string;
  columnMetricsCn: string;
  columnTargetEn: string;
  columnTargetCn: string;
  buttonTextEn: string;
  buttonTextCn: string;
  jumpUrl?: string;
  moreTextEn?: string;
  moreTextCn?: string;
  rows: IKeyPerformanceBenchmarkTableRow[];
  footerEn: string;
  footerCn: string;
  /**
   * 底部联系话术（整句）。用 `**...**` 包裹需加粗的片段，例如：
   * `请联系 **yanxingqi@tencent.com**`
   */
  footerContactLineEn: string;
  footerContactLineCn: string;
  /** 配置后浮层每次展示会上报一次 buriedBtnPoint；不配则不打点 */
  buriedLog?: IKeyPerformanceBenchmarkBuriedLog;
}

export const KEY_PERFORMANCE_BENCHMARK_POPOVER_CONFIG: IKeyPerformanceBenchmarkPopoverConfig =
  {
    titleEn: 'Retention Benchmark',
    titleCn: '留存行业基准',
    columnMetricsEn: 'Metrics',
    columnMetricsCn: '指标',
    columnTargetEn: 'Soft Launch Target',
    columnTargetCn: 'Soft Launch 目标',
    buttonTextEn: 'Benchmark',
    buttonTextCn: '行业基准',
    rows: [
      {
        nameEn: 'D2',
        nameCn: '次留',
        targetEn: '50% – 55%',
        targetCn: '50% – 55%',
        color: 'var(--other-bg34)',
      },
      {
        nameEn: 'D7',
        nameCn: '7留',
        targetEn: '23% – 26%',
        targetCn: '23% – 26%',
        color: 'var(--other-bg73)',
      },
      {
        nameEn: 'D30',
        nameCn: '30留',
        targetEn: '9% – 11%',
        targetCn: '9% – 11%',
        color: '#F5D242',
      },
    ],
    footerEn:
      '*Target is based on the best performance of similar games in the industry and applies only to the early stage of this soft launch (2026.04–2026.05).',
    footerCn:
      '*该数值基于行业对标游戏最佳表现基准，仅适用于本次 soft launch 的早期阶段(2026.04-2026.05)。',
    footerContactLineEn:
      '*Any questions please contact **yanxingqi@tencent.com**',
    footerContactLineCn:
      '*如果您有任何疑问，请联系 **yanxingqi@tencent.com**',
    /** 与 MobileDaily 页 pageId 200101 对齐；buttonId 请替换为后台正式编号 */
    buriedLog: {
      pageId: '200101',
      buttonId: '200101003',
      extInfo: 'overview_mobile_key_perf_benchmark',
      buttonName: 'KeyPerformanceBenchmarkPopover',
      typeId: 'dashboard_pc_v2',
    },
  };
